import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { Icon } from "../../../../components/base";
import { ShaDowBox } from "../../../../components/boxes";
import { NoDataCard } from "../../../../components/parts";
import { COLORS } from "../../../../theme/colors";
import DoubleCircleImg from "../../../../assets/images/icons/double-circle.svg";
import { getData } from "../../../../services";

const useStyles = makeStyles(() => ({
  rightSide: {
    borderRight: `1px solid ${COLORS.darks[0][25]}`,
  },
  metersUnit: {
    marginTop: 20,
  },
  metersUnitBuildings: {
    marginTop: 10,
    fontWeight: "bold",
    fontSize: 16,
  },
  metersCentral: {
    marginTop: 20,
    textAlign: "center",
  },
  metersCentralBuildings: {
    marginTop: 10,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 16,
  },
}));

export const AllBuildingsMeters = () => {
  const classes = useStyles();
  const [meters, setMeters] = useState();
  const title = "Meter Types";
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    getData("/praas/v1/buildings/meters/", setMeters);
  }, [cluster, segments, selectedCountries]);
  if (!meters) return <NoDataCard title={title} rootStyle={{ minHeight: 324 }} />;

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Grid container style={{ marginTop: 38 }}>
          <Grid item sm={6} className={classes.rightSide}>
            <Grid container style={{ width: 102, margin: "0 auto 30px" }}>
              <Grid item xs={6} style={{ marginBottom: 20 }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Icon src={DoubleCircleImg} />
              </Grid>
              <Typography className={classes.metersUnit}>Meter per unit</Typography>
              <Typography className={classes.metersUnitBuildings}>
                {meters.meter_per_unit || 0} Buildings
              </Typography>
            </Grid>
          </Grid>
          <Grid item sm={6}>
            <Icon
              src={DoubleCircleImg}
              style={{
                display: "block",
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 30,
              }}
            />
            <Typography className={classes.metersCentral}>Central meter</Typography>
            <Typography className={classes.metersCentralBuildings}>
              {meters.central || 0} Buildings
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
